/**
 * VueRouter
 * https://router.vuejs.org/zh-cn/
 */
Vue.use(VueRouter)

/**
 * 默认的路由
 * @type {{path: string, component: {template: string}, meta: {auth: boolean}, name: string}[]}
 */
const routes = [
  {
    path: '/',
    redirect: '/document/preview',
  },
  {
    path: '*',
    name: '404',
    component: {
      template: '<sj-exception-page code="404" message="哎呀...找不到页面了！"/>',
    },
    meta: {
      auth: false,
    },
  },
]

/**
 * 创建一个路由
 */
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: routes.concat(...requires.defaults(require.context('../views', true, /\.route\.js$/))),
})

/**
 * 异常路由状态记录
 * @type {{code: null, message: null}}
 */
router.exception = {
  code: null,
  message: null,
}

/**
 * 设置路由异常状态
 * @param code
 * @param message
 */
router.exception.throw = (code, message) => {
  router.exception.code = code
  router.exception.message = message
}

/**
 * 取消路由异常状态
 */
router.exception.cancel = () => {
  router.exception.code = null
  router.exception.message = null
}

/**
 * 在路由执行前
 */
router.beforeEach(async (to, from, next) => {
  // 应用数据准备
  await auth.ready()

  // 切换路由取消上一个页面的请求
  http.cancel('switch to a new route ' + to.path)
  http.createCancel()

  // 重置页面状态
  router.exception.cancel()

  // 是否需要认证
  if (to.meta.auth !== false) {
    // 未登录
    if (!auth.isLogged()) {
      // 进入登录页
      return next(filter.loginPath(to.fullPath))
    }
  } else {
    // 已登录的自动跳转，已登录并在登录页面
    if (auth.isLogged() && to.path === '/login') {
      return next('/')
    }
  }

  return next()
})

export default router
